// main/SimpleLoader.js
import React from "react";
import "./SimpleLoader.css";

const SimpleLoader = () => {
  return (
    <div className="simple-loader-wrapper">
      <div className="spinner-grow" style={{color:'#4f97a1', width: "3rem", height: "3rem"}} role="status" />
    </div>
  );
};

export default SimpleLoader;
